import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid,  RCCInput,  RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import { IEftba019, ITabIntegrationTypesVariables } from "../interface";

const TabVariables : React.FC<ITabIntegrationTypesVariables> = ({
	integrationTypesVariables,
	control,
	error, 
	register
}) => {
 
	const { translate } = useTranslation();

	const { 
		fields, 
		remove,
		append
	} = useFieldArray({
		control,
		name: "eftba019",
		shouldUnregister: true
	});

	useEffect(() => {
		remove();
		if(integrationTypesVariables)
			append(integrationTypesVariables);
	}, [integrationTypesVariables]);

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
			>
				<RCCGrid
					container
					item	
					justifyContent="center"	
				>
					<RCCGrid
						item
						container
						xs={12}
						sm={10}	
						justifyContent="flex-end"
					>
						<RCCTooltip
							text={translate("Adicionar variável")}
							color="purple"
						>	
							<RCCButton
								icon={{name: "plus"}}
								color="purple"
								onClick={() => {
									append({} as IEftba019);
								}}
								size="md"
								layout="isRounded"
							/>
						</RCCTooltip>
					</RCCGrid>
					<RCCGrid
						container
						item
						xs={12}
						sm={10}	
					>
						{!fields || fields.length <= 0 ? (
							<>
								<RCCAlert 
									title={translate("Atenção")}
									description={translate("Nenhuma Variável encontrada")}
								/>
							</>
						) : (
							<>
								{/* Informações */}
								<RCCGrid
									container
									item
								>
									<RCCGrid 
										item
										container	
										xs={12}			
										direction="column"
										alignItems="center"
									>
										<RCCGrid
											container
											item
											xs={12}
											md={12}
											justifyContent="center"
											alignItems="center"
										>
											{/* Item */}
											{fields && fields.map((item: any, index: number) => (
												<React.Fragment key={v4()}>
													<RCCGrid
														container
														item
														xs={12}
														spacing={1}
													>
														<RCCGrid
															container
															item
															xs={12}
															sm={5}
															md={5}
															justifyContent="center"
															alignContent="center"
														>
															<RCCInput 
																name={`eftba019[${index}].efa019Nome`}
																register={register}
																label={translate("Nome")}
																defaultValue={item.efa019Nome}
																error={error.eftba019 && error?.eftba019[index]?.efa019Nome}
																maxLength={60}
																required                             
															/>
														</RCCGrid>
														<RCCGrid
															container
															item
															xs={12}
															sm={5}
															md={5}
															justifyContent="center"
															alignContent="center"
														>
															<RCCInput 
																name={`eftba019[${index}].efa019Descricao`}
																register={register}
																label={translate("Descrição")}
																defaultValue={item.efa019Descricao}
																error={error.eftba019 && error?.eftba019[index]?.efa019Descricao}
																maxLength={20}
																required                             
															/>
														</RCCGrid>
														<RCCGrid
															container
															item
															xs={2}
															sm={2}
															md={2}
															justifyContent="center"
															alignContent="center"
														>
															<RCCTooltip
																color="red"
																text={translate("Excluir")}
															>
																<RCCButton
																	color="red"
																	onClick={() => {remove(index);}}
																	icon={{
																		name: "trash"
																	}}
																	layout="default"
																/>
															</RCCTooltip>
														</RCCGrid>
													</RCCGrid>
													<hr />
												</React.Fragment>
											))}
										</RCCGrid>
									</RCCGrid>
								</RCCGrid>
							</>
						)}
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</>
	);
};



export default TabVariables;
